jQuery(document).ready(function($) {
	controllerSubMenu = new ScrollMagic.Controller();

  if($('#mastheadvideo').length > 1) {
    $("#mastheadvideo").get(0).play();
  }


  $('body').addClass('page-loading');
  setTimeout(function(){
    $('body').addClass('page-loaded');
  }, 3000);

/* ====================== HOME PAGE MASTHEAD ANIMATION ======================  */

  $(window).scroll(function() {
      var scroll = $(window).scrollTop();

      if (scroll >= 130) {
          $(".header").addClass("header--collapsed");
      } else {
        $(".header").removeClass("header--collapsed");
      }
  });

/* ====================== HOME PAGE MASTHEAD ANIMATION ======================  */
  function mastHeadScrollAnimation() {
    var controller = new ScrollMagic.Controller();
    var containerWidth = '';
    var amendedwidth = '';

    if($(window).width() > 768 && $(window).width() < 992) {
      containerWidth = $(window).width();
    } else if($(window).width() >= 992 && $(window).width() < 1200) {
      containerWidth = 940
    } else if($(window).width() > 1200) {
      containerWidth = 1140;
    }

    if ($(window).width() < 992) {
      if(controller) {
        controller.destroy(true);
        controller = null;
      }
    } else {
       if(controller == null) {
          controller = new ScrollMagic.Controller();
       } else {
          controller.destroy(true);
          controller = null;
          controller = new ScrollMagic.Controller();
       }
        amendedwidth = ($(window).width() - containerWidth)/2;

        var headerAnimation = new TimelineMax();
        headerAnimation
          .to( $('.masthead__video'), 1, {left: amendedwidth});

        var testimonialsAnimaton = new TimelineMax();
        testimonialsAnimaton
          .to( $('.testimonials__overlay'), 1, {width: amendedwidth});

        if($('body').hasClass('home')) {
          var headerScene = new ScrollMagic.Scene({triggerElement: ".masthead--home", triggerHook: 0, duration: "60%"})
            .setTween(headerAnimation)
            .addTo(controller);
        }

        if($('.become-member').length > 0) {
          var testimonialsScene = new ScrollMagic.Scene({triggerElement: ".become-member", triggerHook: 0, duration: "60%"})
            .setTween(testimonialsAnimaton)
            .addTo(controller);
        }
     }
  }

/* ====================== MEMBERS CAROUSEL ======================  */
    $('.members__logos').slick({
  		infinite: true,
  		slidesToShow: 5,
  		slidesToScroll: 5,
  		autoplay: true,
  		autoplaySpeed: 1500,
  		dots: false,
  		prevArrow: false,
  		nextArrow: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
          }
        },
        {
          breakpoint: 768,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
          }
        },
        {
          breakpoint: 480,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
          }
        }
      ]
    });

/* ====================== TESTIMONIALS CAROUSEL ======================  */
  $('.testimonials__slider').slick({
		dots: true,
		prevArrow: false,
		nextArrow: false,
		cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
		fade: true,
		autoplay: true,
		autoplaySpeed: 4000,
  });

/* ====================== CHO TEAM CAROUSEL ======================  */
  $('.team-slider').slick({
		dots: false,
		prevArrow: '<div><i class="fas fa-angle-left"></i></div>',
		nextArrow: '<div><i class="fas fa-angle-right"></i></div>',
		cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
		fade: true,
		autoplay: true,
		autoplaySpeed: 5000,
  });

/* ====================== CONTENT MORE TOGGLE ======================  */
  $('.content-block__toggle').on("click", function() {
  	$(this).toggleClass('content-block__toggle--active');
  	$(this).parent().find('.content-block__more').slideToggle();
  	$(this).find('span').text(function(i, v) { return v == "Read More" ? "Read Less" : "Read More"; });
  })

/* ====================== SUB MENU ON CLOCK  ======================  */
  $('.sub-nav__links a[href^="#"]').on('click', function(event) {
    var target = $(this.getAttribute('href'));
    if( target.length ) {
        event.preventDefault();
        $('html, body').stop().animate({
            scrollTop: target.offset().top - 87
        }, 1000);
    }
  });

/* ====================== ADD ACTIVE CLASS TO SUBMENU ON SCROLL  ======================  */
  $('.sub-nav__anchor').waypoint(function(direction) {
    var id = this.element.id;

    $('.sub-nav__links li').removeClass('active');

    if(direction == 'up') {
      $('.sub-nav__links li a[href="#'+id+'"]').parent().prev().addClass('active');
    } else {
      $('.sub-nav__links li a[href="#'+id+'"]').parent().addClass('active');
    }

  }, { offset: '180px' });

/* ====================== NEWS FIXED SIDEBAR ======================  */
    function subMenuAnimation() {
      if($(window).width() < 768) {
        if(controllerSubMenu) {
          controllerSubMenu.destroy(true);
          controllerSubMenu = null;
        }
      } else {
         if(controllerSubMenu == null) {
            controllerSubMenu = new ScrollMagic.Controller();
         } else {
            controllerSubMenu.destroy(true);
            controllerSubMenu = null;
            controllerSubMenu = new ScrollMagic.Controller();
         }

          if($('.sub-nav').length > 0) {
            innerMain = $('.page-content').height();
            sideBar = $('.sub-nav').height();
            duration = (innerMain - sideBar);

            careersSidebar = new ScrollMagic.Scene({triggerElement: ".sub-nav", triggerHook: 'onLeave', offset: -120, duration: duration})
                      .setPin(".sub-nav")
                      .addTo(controllerSubMenu);
          }
      }
    }

	subMenuAnimation();

/* ====================== MEMBER TABLE ROW TOGGLE ======================  */
  $('.member-table__row').on("click", function() {
    $(this).toggleClass('member-table__row--active');
    $(this).find('.member-table__column--main p').slideToggle();
    $(this).find('.member-table__column--representatives span:not(:first-of-type)').slideToggle();
    $(this).find('.member-table__column').last().slideToggle();

    if($(window).width() < 768) {
      $(this).find('.member-table__column--representatives').slideToggle();
    }
  })

/* ====================== TABS TOGGLE ======================  */
  $(".tabs .tabs__link").first().on("click", function() {
      $(this).toggleClass('clicked');
      $('.tabs .tabs__link').not(":eq(0)").toggle();
  })

  $(".tabs .tabs__link:nth-of-type(2)").addClass("tabs__link--active");
  $(".tabs-content .tab-content").first().addClass("tab-content--active");

  var uiTab = $('.tabs .tabs__link').not(":eq(0)");
  var uiTabContent = $('.tabs-content .tab-content');

  uiTab.on("click", function() {
    var tab = $(this).attr("data-tab");
    toggleTab(tab);
  })

  var toggleTab = function(tab) {
      uiTab.removeClass('tabs__link--active');
      uiTabContent.removeClass('tab-content--active');

      $('.tabs .tabs__link[data-tab="'+tab+'"]').addClass('tabs__link--active');
      $('.tabs-content .tab-content[data-tab="'+tab+'"]').addClass('tab-content--active');
      $('.tabs .tabs__link').not(":eq(0)").toggle();
      $(".tabs .tabs__link").first().toggleClass('clicked');
  }

/* ====================== MODULES FADE IN ======================  */
  $( ".articles .post-card" ).each(function( index ) {
    var waypoints = $(this).waypoint(function(direction) {
      $(this.element).toggleClass('post-card--active');
    }, {
      offset: '90%'
    });
  });

/* ====================== EVENTS FADE IN ======================  */
  $( ".events .event" ).each(function( index ) {
    var waypoints = $(this).waypoint(function(direction) {
      $(this.element).toggleClass('event--active');
    }, {
      offset: '90%'
    });
  });

/* ====================== EVENT MORE TOGGLE ======================  */
  $('.event .event__more').on("click", function() {
    $(this).toggleClass('event__more--active')
    $(this).parent().find('.event__details p:not(:first-of-type)').slideToggle();
    $(this).find('span').text(function(i, v) { return v == "Read More" ? "Read Less" : "Read More"; });
  });

/* ====================== MOBILE MENU TOGGLE ======================  */
  $('.menu-toggle').on("click", function(e){
    var type = $(this).attr("data-type");
    toggleNavClass(type);
  });

  function toggleNavClass(type) {
    $('.menu-toggle').toggleClass('menu-toggle--open');
    $('body').toggleClass('navopen');
    if(type == 'main') {
      $('.navigation').toggleClass('navigation--open');
    }

    if(type == 'members') {
      $('.account__sidebar').toggleClass('account__sidebar--open');
    }
    // $('.header').toggleClass('header--navopen');
  }


/* ====================== EDIT PROFILE TOGGLES ======================  */

  // CHO MEMBERSHIP INVOICE ADDRESS
  $('[name="acf[field_5ab517be7072b]"]').on("click", function() {
    var value = $(this).val();
    if(value == 'other') {
      $('.acf-field[data-name="invoice_address1"]').slideDown();
      $('.acf-field[data-name="invoice_address2"]').slideDown();
      $('.acf-field[data-name="invoice_address3"]').slideDown();
      $('.acf-field[data-name="invoice_postcode"]').slideDown();
    } else {
      $('.acf-field[data-name="invoice_address1"]').slideUp();
      $('.acf-field[data-name="invoice_address2"]').slideUp();
      $('.acf-field[data-name="invoice_address3"]').slideUp();
      $('.acf-field[data-name="invoice_postcode"]').slideUp();
      $('.acf-field[data-name="invoice_address1"]').find('input').val('');
      $('.acf-field[data-name="invoice_address2"]').find('input').val('');
      $('.acf-field[data-name="invoice_address3"]').find('input').val('');
      $('.acf-field[data-name="invoice_postcode"]').find('input').val('');
    }
  })

  // ADDITION OFFICES/DEPOTS
  $('[name="acf[field_5ab5196ce176d]"]').on("click", function() {
    var value = $(this).val();
    if(value == 'yes') {
      $('.acf-field[data-name="additional_offices"]').slideDown();
    } else {
      $('.acf-field[data-name="additional_offices"]').slideUp();
      $('.acf-field[data-name="additional_offices"]').find('input').val('');
    }
  })

  // ADDITIONAL TRADING NAMES
  $('[name="acf[field_5ab519bc7c043]"]').on("click", function() {
    var value = $(this).val();
    if(value == 'yes') {
      $('.acf-field[data-name="additional_trading_names"]').slideDown();
    } else {
      $('.acf-field[data-name="additional_trading_names"]').slideUp();
      $('.acf-field[data-name="additional_trading_names"]').find('input').val('');
    }
  })

/* ====================== DETERMINE DEVICE ======================  */
  function determineAgent() {
    var deviceAgent = navigator.userAgent;
    if((/Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i).test(navigator.userAgent || navigator.vendor || window.opera)) {
      $('.masthead__video').remove();
    }
  };

  determineAgent();
  mastHeadScrollAnimation();

/* Resize run functions
=============================================== */
  $(window).resize(function(){
    determineAgent();
    mastHeadScrollAnimation();
  });

  $("#download_filter").on("change", function(e) {
    this.form.submit();
  })
});
